import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import { showConfirmModal } from '../../modules/modals/confirmService';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';
import PaginationTable from '../../components/Pagination/PaginationTable';

@inject('dischargeStore', 'scheduleStore', 'batchStore')
@observer
class TruckChargeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [],
      error: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
    const { scheduleStore } = this.props;

    if (!scheduleStore.trucks.length) {
      scheduleStore.loadTrucks();
    }
    if (!scheduleStore.drivers.length) {
      scheduleStore.loadDrivers();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onAdd = () => {
    this.setState({
      error: null,
    });

    this.props.dischargeStore.selectTruckCharge(-1);
  };

  onEdit = id => {
    this.setState({
      error: null,
    });

    this.props.dischargeStore.selectTruckCharge(id);
  };

  onRemove = id => {
    const { dischargeStore, t } = this.props;

    this.setState({
      error: null,
    });

    showConfirmModal({
      title: t('Do you want to remove charge?', {id}),
      okLabel: t('Yes'),
      cancelLabel: t('No'),
      enableEscape: false,
    }).then(() => {
      dischargeStore.removeTruckCharge(id)
        .catch(e => {
          if (!this.mounted) {
            return;
          }
          this.setState({
            error: `${e.message}`,
          });
        });
    });
  };

  getColumns = () => {
    const { scheduleStore, dischargeStore, batchStore, t } = this.props;
    const { sorted } = this.state;

    return [
      {
        headerText: t('ID'),
        accessor: 'id',
        id: 'id',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Truck'),
        accessor: d => {
          if (d.truckId) {
            const truck = scheduleStore.trucks.find(v => v.id === d.truckId);
            return truck ? truck.code : '';
          }
          return '';
        },
        id: 'truckId',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Sequence'),
        accessor: 'dischargeSequenceId',
        Cell: row => (dischargeStore.getDischargeSequenceName(row.original.dischargeSequenceId)),
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Default Rate'),
        accessor: 'rate',
        id: 'rate',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Capacity'),
        accessor: d => {
          if (d.truckId) {
            const truck = scheduleStore.trucks.find(v => v.id === d.truckId);
            const unit = truck && truck.maximumLoadUnitId ? batchStore.getUnitById(truck.maximumLoadUnitId) : '';
            return truck ? `${truck.maximumLoadSize || 0} ${unit}` : 0;
          }
          return 0;
        },
        id: 'capacity',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Driver'),
        accessor: d => {
          if (d.driverId) {
            const driver = scheduleStore.drivers.find(v => v.id === d.driverId);
            return driver ? driver.name : '';
          }
          return '';
        },
        id: 'driverId',
        ...getSortHeaderProps(sorted),
      },
      {
        accessor: 'actions',
        maxWidth: 70,
        Cell: row => (
          <div className="text-right">
            <a className="btn btn-sm btn-default btn-action"
              title={t('Edit')}
              onClick={() => this.onEdit(row.original.id)}>
              <i className="fa fa-pencil"/>
            </a>
            <a className="btn btn-sm btn-default btn-action"
              title={t('Delete')}
              onClick={() => this.onRemove(row.original.id)}>
              <i className="fa fa-remove"/>
            </a>
          </div>
        ),
      },
    ];
  };

  render() {
    const { dischargeStore, scheduleStore, t } = this.props;
    const { truckCharge } = dischargeStore;
    const { trucks } = scheduleStore;

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{t('Truck Charge')}</PortletCaption>
          <a className="btn btn-sm btn-default btn-action pull-right"
            title={t('Add')}
            onClick={this.onAdd}>
            <i className="fa fa-plus"/>
          </a>
        </PortletTitle>
        <PortletBody>
          {truckCharge.length && trucks.length ? (
            <ReactTable
              className={'-highlight truck-charge-table'}
              data={truckCharge}
              columns={this.getColumns()}
              sorted={this.state.sorted}
              onSortedChange={sorted => this.setState({ sorted })}
              showPaginationTop={false}
              showPaginationBottom={true}
              showPageSizeOptions={true}
              PaginationComponent={PaginationTable}
              resizable={false}
              minRows={1}
              defaultPageSize={25}
            />
          )
            : ''}
        </PortletBody>
      </Portlet>
    );
  };
}

export default withTranslation()(TruckChargeList);
